/**
 * @packageDocumentation
 * @module      P_Drive_SensorStatusDrive3.ts
 * @description Contains Emc related data for Sensor Drive 3
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import { toFixedDecimal } from "../utils";
export default class P_Drive_SensorStatusDrive3 {
    constructor() {
        this.CasetteOpenClose = '0';
        this.CasetteLockedUnlocked = '0';
        this.CasetteTube = '0';
        this.Estop = '0';
    }
    static fromJSON(json) {
        if (json) {
            let p_Drive_SensorStatusDrive3 = new P_Drive_SensorStatusDrive3();
            if (json.CasetteOpenClose) {
                p_Drive_SensorStatusDrive3.CasetteOpenClose = toFixedDecimal(json.CasetteOpenClose);
            }
            if (json.CasetteLockedUnlocked) {
                p_Drive_SensorStatusDrive3.CasetteLockedUnlocked = toFixedDecimal(json.CasetteLockedUnlocked);
            }
            if (json.CasetteTube) {
                p_Drive_SensorStatusDrive3.CasetteTube = toFixedDecimal(json.CasetteTube);
            }
            if (json.Estop) {
                p_Drive_SensorStatusDrive3.Estop = toFixedDecimal(json.Estop);
            }
            return p_Drive_SensorStatusDrive3;
        }
        return null;
    }
}
//# sourceMappingURL=P_Drive_SensorStatusDrive3.js.map